function onEnterDirective() {
  return {
    restrict: 'A',
    controller: 'onEnterController as ctrl',
    scope: {
      onEnter: '&',
    },
  };
}

export default onEnterDirective;



// WEBPACK FOOTER //
// ./src/modules/utils/lsp-keyboard/components/on-enter/on-enter-directive.js